import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-expedia-wizard-complete',
  templateUrl: './connect-expedia-wizard-complete.component.html',
  styleUrls: ['./connect-expedia-wizard-complete.component.scss'],
})
export class ConnectExpediaWizardCompleteComponent implements OnInit {
  @Output() reset = new EventEmitter()
  @Output() channel = new EventEmitter()
  @Output() done = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
